<template>
  <el-dialog
    :close-on-click-modal="false"
    title="装卸货有效范围设置"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
      />
      <section
          class="tipBox error"
      >设置装卸货的有效范围，设置后，司机到达范围内，即可完成订单状态的变更。</section>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {addFenceCustomerLine} from 'api/archives';
import {dealNumber, dealZero} from '@qx/utils';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '起点范围',
            value: 'sourceRadius',
            type: 'input',
            placeholder: '请输入起点范围',
            onInput: (sourceRadius) => {
              this.$refs.customForm.setVal('sourceRadius', dealZero(String(dealNumber(sourceRadius, false)), false));
            },
          },
          {
            label: '终点范围',
            value: 'desRadius',
            type: 'input',
            placeholder: '请输入终点范围',
            onInput: (desRadius) => {
              this.$refs.customForm.setVal('desRadius', dealZero(String(dealNumber(desRadius, false)), false));
            },
          },
        ],
        rules: {
          sourceRadius: [
            { required: true, message: '请输入起点范围', trigger: 'blur' },
          ],
          desRadius: [
            { required: true, message: '请输入终点范围', trigger: 'blur' },
          ],

        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$refs.customForm && this.$refs.customForm.reset();
      if (item) { // 修改
        this.type = 'edit';
        this.originData = item;
      } else { // 新增
        this.type = 'add';
      }
      this.$nextTick(() => {
        this.$refs.customForm.setVal(item);
      });

    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const res = await addFenceCustomerLine({
        lineId: this.originData.lineId,
        sourceRadius: form.sourceRadius,
        desRadius: form.desRadius,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tipBox {
  line-height: 18px;
  background: #f0f2f5;
  width: 100%;
  top: 80px;
  left: 0;
  padding: 6px 24px;
  box-sizing: border-box;
}
</style>
